import React from 'react'
import Grid from '@material-ui/core/Grid'
import ViewUpload from 'EurestoComponents/Upload/ViewUpload'
import Modal from './Modal'
import EurestoDiv from 'EurestoComponents/EurestoDiv'
import project from 'EurestoConfig/project.config'
import ApiRequest from 'EurestoApi/ApiRequest'
import {Fab} from '@material-ui/core'

export default class extends React.Component {
  constructor (props) {
    super(props)
    this.state = {
      showModalUpload: false
    }
  }

  render () {
    return <Grid container spacing={0} style={{ margin: 0, padding: 0, marginBottom: 5 }} alignItems={'center'}
                 justify={'center'}>
      {this.props.media_id &&
      <Grid item style={{ margin: 0, padding: 0 }} xs={12}>
        <Grid container spacing={0} style={{ margin: 0, padding: 0, marginBottom: 5 }} alignItems={'center'}
              justify={'center'}>
          <Grid item style={{ margin: 0, padding: 0 }} xs={6}>
            <a href={this.props.lien} target="_blank"><Fab size="small" className={'EurestoSecondary--text EurestoPrimary'}><i
              className={'ei-commun_visualiser'}/></Fab></a>
          </Grid>
          {!this.props.disabled && <Grid item style={{ margin: 0, padding: 0 }} xs={6}>
            <Fab size="small" className={'EurestoError--text EurestoPrimary'} onClick={this.handleDeleteFile}><i
              className={'ei-commun_fermer'}/></Fab>
          </Grid>}
        </Grid>
      </Grid>
      ||
      <Grid item style={{ margin: 0, padding: 0 }} xs={12}>
        <Fab onClick={() => this.handleClickModalUpload(true)} size="small"
                className={'EurestoSecondary--text EurestoPrimary'}>
          <i className={'fa fa-upload'}/>
        </Fab>
      </Grid>
      }
      {
        this.state.showModalUpload &&
        <Modal
          key={this.state.showModalUpload}
          grid={{xs: 6}}
          open={this.state.showModalUpload}
          onClose={() => this.handleClickModalUpload(false)}>
          <EurestoDiv
            title={'Nouveau dossier'}
            buttonsRight={[
              {
                icon: ' ei-commun_fermer',
                cb: () => this.handleClickModalUpload(false),
                className: 'EurestoError--text EurestoText'
              }
            ]}><ViewUpload contact_id={this.props.client_id} handleUpload={this.handleUpload}/>
          </EurestoDiv>
        </Modal>
      }
    </Grid>
  }

  handleUpload = (result) => {
    this.setState({
      showModalUpload: false
    }, () => this.props.onChange(result))
  }

  handleClickModalUpload = (view) => {
    this.setState({
      showModalUpload: view
    })
  }


  handleDeleteFile = async _ => {
    const result = await ApiRequest(project.api + 'upload', {
      action: 'delete',
      requete: 'upload',
      id: this.props.media_id,
    }, { showAlertError: false})
    this.props.onChange({})
  }
}



// WEBPACK FOOTER //
// ./app/Components/Upload.js